import request, { Methods, withToken } from "../../../utils/request";
import { getUserCompany } from "../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const CANCEL_PERSONNEL_ACTIONS_DEFAULT = "CANCEL_PERSONNEL_ACTIONS_DEFAULT";
export const CANCEL_PERSONNEL_ACTIONS_REQUEST = "CANCEL_PERSONNEL_ACTIONS_REQUEST";
export const CANCEL_PERSONNEL_ACTIONS_SUCCESS = "CANCEL_PERSONNEL_ACTIONS_SUCCESS";
export const CANCEL_PERSONNEL_ACTIONS_ERROR = "CANCEL_PERSONNEL_ACTIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const cancelPersonnelActionsDefault = () => ({
  type: CANCEL_PERSONNEL_ACTIONS_DEFAULT,
});

export const cancelPersonnelActionsRequest = (payload = {}, callback) => ({
  type: CANCEL_PERSONNEL_ACTIONS_REQUEST,
  payload,
  callback,
});

export const cancelPersonnelActionsSuccess = (data) => ({
  type: CANCEL_PERSONNEL_ACTIONS_SUCCESS,
  payload: data,
});

export const cancelPersonnelActionsError = (error) => ({
  type: CANCEL_PERSONNEL_ACTIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const cancelPersonnelActionsServiceRequest = async ({ personnelActionId, ...formData }) => {
  const options = await withToken({
    method: Methods.PUT,
    headers: { CompanyId: await getUserCompany() },
    data: { ...formData }
  });
  return request(`personnel_actions/${personnelActionId}/cancel`, options);
};
